import styled from 'styled-components';

export const Nav = styled.nav`
	display: flex;
	background-color: #c8c8c8;
	width: 90%;
	margin: auto;
`;
export const NavItem = styled.div`
	flex: 1;
	padding: 10px 10px;
	text-align: center;
	color: #fff;
	font-size: 10px;
	font-weight: bold;
	background-color: ${props => (props.active ? '#5cb335' : 'grey')};
	cursor: pointer;
	transition: background-color 0.3s ease, color 0.3s ease;
`;
